const SEEN_TRENDING_STORAGE_KEY = 'trending:seen-item-ids';
const MAX_SEEN_TRENDING_ITEMS = 150;

export const getSeenTrendingIds = () => {
  try {
    const raw = window.localStorage.getItem(SEEN_TRENDING_STORAGE_KEY);

    if (!raw) {
      return [];
    }

    const parsed = JSON.parse(raw);

    return Array.isArray(parsed) ? parsed.filter(Boolean) : [];
  } catch (error) {
    return [];
  }
};

export const markTrendingItemSeen = id => {
  if (!id) {
    return;
  }

  try {
    const ids = getSeenTrendingIds();

    if (ids.includes(id)) {
      return;
    }

    ids.push(id);

    while (ids.length > MAX_SEEN_TRENDING_ITEMS) {
      ids.shift();
    }

    window.localStorage.setItem(SEEN_TRENDING_STORAGE_KEY, JSON.stringify(ids));
  } catch (error) {}
};
